module.exports = __webpack_public_path__ + "static/entrepreneur-4-2024-03c44014606255a7c995bf9e90cc6acc.webp";